import { createReducer } from '@reduxjs/toolkit';
import keyBy from 'lodash/keyBy';
import * as actions from '../actions';
import { formatPreferences } from '../helpers';
import { NotificationsPreferencesState, PostToggleAction, ToggleAction } from '../types';

const preferencesDataInitialState = {
  channels: {},
  categories: {}
};

export const preferencesInitialState: NotificationsPreferencesState = {
  isFetching: false,
  error: null,
  data: preferencesDataInitialState
};

const notificationsPreferencesReducer = createReducer(preferencesInitialState, {
  [actions.GET_NOTIFICATIONS_PREFERENCES]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.GET_NOTIFICATIONS_PREFERENCES_SUCCESS]: (state, action) => {
    const { data } = action.payload;
    const { hasPushPermissions } = action.meta.previousAction.payload;
    const { channels, categories } = data.notificationPreferences;
    const categoriesFormatted = formatPreferences(categories);
    const channelsFormatted = formatPreferences(channels, hasPushPermissions);

    state.data = {
      channels: keyBy(channelsFormatted, 'key'),
      categories: keyBy(categoriesFormatted, 'key')
    };

    state.isFetching = false;
  },
  [actions.GET_NOTIFICATIONS_PREFERENCES_FAIL]: (state, action) => {
    state.isFetching = false;
    state.data = preferencesDataInitialState;
    state.error = action.error;
  },
  [actions.TOGGLE_NOTIFICATIONS_PREFERENCE]: (state, action: ToggleAction) => {
    const { key, type } = action.payload;
    const item = state.data[type][key];
    item.enabled = !item.enabled;
  },
  [actions.TOGGLE_NOTIFICATIONS_PREFERENCE_SUCCESS]: () => {
    // Anything?
  },
  [actions.TOGGLE_NOTIFICATIONS_PREFERENCE_FAIL]: (state, action: PostToggleAction) => {
    if (action.error && action.error.response) {
      const { key, type } = action.meta.previousAction.payload;
      const item = state.data[type][key];
      item.enabled = !item.enabled;
    }
  },
  [actions.TOGGLE_NOTIFICATIONS_CHANNELS_OFF]: state => {
    for (const channel of Object.values(state.data.channels)) {
      channel.enabled = false;
    }
  },
  [actions.TOGGLE_NOTIFICATIONS_CHANNELS_OFF_SUCCESS]: () => {
    // Anything?
  },
  [actions.TOGGLE_NOTIFICATIONS_CHANNELS_OFF_FAIL]: () => {
    // Anything?
  }
});

export default notificationsPreferencesReducer;
